<div *ngIf="Loading == false && PersonSelected() == false" class="si-Border">
	<h4 class="NullDisplay">No {{ AudienceMode }} Selected</h4>
</div>
<div *ngIf="Loading == true" class="si-Border">
	<h4 class="NullDisplay">...Loading</h4>
</div>
<div *ngIf="Loading == false && PersonSelected() == true" class="si-Border">
	<!--Student-->
	<div *ngIf="IsStudent() == true">
		<!--Main Grid (2 cols)-->
		<div class="si-Grid">
			<!--Left Column-->
			<div class="si-Center">
				<img class="MaxImgSize" *ngIf="PhotoData" src="{{ PhotoData }}" />

				<div style="display: grid; grid-row-gap: 5px">
					<h5>{{ FirstName }}</h5>
					<h5>{{ LastName }}</h5>
					<label>{{ DesignatorID }}</label>
					<label>{{ Status }}</label>
				</div>
			</div>

			<!--Right Column (2 cols)-->
			<div class="si-SmallGrid">
				<label>Fine Owed:</label>
				<label>{{ FineOwed }}</label>

				<label>Tardies this Month:</label>
				<label>{{ TardyMTD }}</label>

				<label>Absences this Month:</label>
				<label>{{ AbsentMTD }}</label>

				<label>Class Cuts this Month:</label>
				<label>{{ CutsMTD }}</label>

				<label>Home School:</label>
				<label>{{ SchoolNBR }}</label>

				<label>Homeroom:</label>
				<label>{{ Homeroom }}</label>

				<label>Academy:</label>
				<label>{{ Academy }}</label>

				<label>Grade:</label>
				<label>{{ Grade }}</label>

				<label>Student In School:</label>
				<label>{{ InSchool }}</label>
			</div>
		</div>

		<!--Bottom Text-->
		<div class="si-Center si-MarginTop10">
			<label>{{ SecondaryStatus }}</label>
		</div>
	</div>

	<!--Staff-->
	<div *ngIf="IsStudent() == false">
		<div class="si-GridWImage">
			<img class="si-Image MaxImgSize" *ngIf="PhotoData" src="{{ PhotoData }}" />

			<!--Main Grid (2 cols)-->
			<div class="si-Grid">
				<h5 *ngIf="FirstName != ''">First Name:</h5>
				<h5 *ngIf="FirstName != ''">{{ FirstName }}</h5>

				<h5 *ngIf="LastName != ''">Last Name:</h5>
				<h5 *ngIf="LastName != ''">{{ LastName }}</h5>

				<label *ngIf="StaffTitle != ''">Title:</label>
				<label *ngIf="StaffTitle != ''">{{ StaffTitle }}</label>

				<label>StaffID:</label>
				<label>{{ DesignatorID }}</label>

				<label>Status:</label>
				<label>{{ Status }}</label>

				<label>Home School:</label>
				<label>{{ SchoolNBR }}</label>
			</div>
		</div>

		<!--Bottom Text-->
		<div *ngIf="SecondaryStatus != ''" class="si-Center si-MarginTop10">
			<label>{{ SecondaryStatus }}</label>
		</div>
	</div>
</div>
